import BaseObject from "./BaseObject.js";
import appConfig from "../../config/app_config";
export default class BatchObject {
  static _objectDefinition() {
    return {
      name: "",
      eventId: 0,
      batchGroupId: 0,
      batchId: 0,
      startTime: 0,
      price: 0.0,
      maxInflow: 0,
      nrOfRegistrations: 0,
      chainable: 0
    };
  }

  static _createArrayWithObjects(batchObject) {
    let result = BaseObject._createArrayWithObjects(batchObject);
    return result;
  }

  static _createGetContainerRequest(object) {
    let o = {
      // Polyline: object.polyline,
      // Lat: object.lat,
      // Lon: object.lon
    };

    return o;
  }

  static _createRequestObject(object) {
    let req = {
      Batch: {
        Name: object.name,
        EventId: Number(object.eventId),
        BatchGroupId: Number(object.batchGroupId),
        BatchId: Number(object.batchId),
        StartTime: Number(object.startTime),
        Price: Number(object.price),
        maxInflow: Number(object.maxInflow),
        NrOfRegistrations: Number(object.nrOfRegistrations),
        Chainable: Number(object.chainable)
      }
      //   Tags: '',
      //   Containers: ''
    };

    return req;
  }

  static _createSaveBatchSelection(batches, userId, groupSize) {
    let batchesSelection = {};
    if (Array.isArray(batches)) {
      batches.forEach((e, index) => {
        batchesSelection[e.BatchGroupId] = {
          Selected: true,
          GroupSize: Number(groupSize),
          PreferredArrivalTime: Number(e.StartTime) - 900
        };
      });
    } else {
      batchesSelection[batches.BatchId] = {
        Selected: true,
        GroupSize: groupSize,
        PreferredArrivalTime: Number(batches.StartTime) - 900
      };
    }

    const req = {
      UserId: userId,
      Batches: batchesSelection
    };

    return req;
  }
}
